export default function Prediction() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="3.75" fill="#D1EFFF" />
      <circle cx="12" cy="11" r="5" stroke="#0070F2" stroke-width="1.5" />
      <path
        d="M6.3618 17.2764L8 14L9 15L10 15.5L10.1056 15.5528C10.6938 15.8469 11.3424 16 12 16C12.6576 16 13.3062 15.8469 13.8944 15.5528L14 15.5C14.6623 15.1688 15.2669 14.7331 15.7906 14.2094L16 14L17.6382 17.2764C17.8044 17.6088 17.5627 18 17.191 18H6.80902C6.43733 18 6.19558 17.6088 6.3618 17.2764Z"
        stroke="#0070F2"
        stroke-width="1.5"
      />
      <path
        d="M11.6691 8.62017C11.8103 8.35552 12.1897 8.35552 12.3309 8.62017L12.99 9.85566C13.025 9.92128 13.0787 9.975 13.1443 10.01L14.3798 10.6691C14.6445 10.8103 14.6445 11.1897 14.3798 11.3309L13.1443 11.99C13.0787 12.025 13.025 12.0787 12.99 12.1443L12.3309 13.3798C12.1897 13.6445 11.8103 13.6445 11.6691 13.3798L11.01 12.1443C10.975 12.0787 10.9213 12.025 10.8557 11.99L9.62017 11.3309C9.35552 11.1897 9.35552 10.8103 9.62017 10.6691L10.8557 10.01C10.9213 9.975 10.975 9.92128 11.01 9.85566L11.6691 8.62017Z"
        fill="#0070F2"
      />
    </svg>
  );
}
